import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { Divider, Tooltip } from "antd";
import TabelaPadrao from "../../components/TabelaPadrao";
import { LabelPadrao, LegendaEntrega, LoadingContainerPadrao, TextAreaPadrao } from "../../components/Base";
import formatarData from "../../Utils/formatarData";
import { useFetch } from "../../components/Hooks/Conexao";
import culture from "../../Utils/Culture";
import toLocale from "../../Utils/ToLocaleString";

function PreVendaDetalhesPadrao({ id, title, modelo, ...props }) {
  const [preVenda, listar, loading] = useFetch(() => props.fetch().post(`prevenda/get/${id}`, {}));

  useEffect(() => {
    if (!!id)
      listar();
  }, [id]);

  const entrega = preVenda?.entrega;

  return <LoadingContainerPadrao loading={loading} style={{ minHeight: 400 }}>
    {!!preVenda && <>
      <div style={{ display: "flex" }}>
        <p><b>Número: </b>{preVenda.numero}</p>
        <p style={{ margin: "0 10px" }}><b>Data: </b>{formatarData(preVenda.data).DATAHORA}</p>
        <p><b>Empresa: </b>{preVenda.empresa}</p>
      </div>

      <div style={{ display: "flex" }}>
        {!!preVenda.cliente && <p style={{ marginRight: 10 }}><b>Cliente: </b>{preVenda.cliente}</p>}
        {!!preVenda.vendedor && <p><b>Vendedor: </b>{preVenda.vendedor}</p>}
      </div>

      {!!entrega && <>
        <Divider orientation="left">Entrega</Divider>
        <LegendaEntrega status={entrega?.status} />
        <p style={{ marginRight: 10, marginTop: 10 }}><b>Endereço: </b>{entrega.logradouro}, {entrega.numero}, {entrega.bairro}, {entrega.complemento} - {entrega.cidade}, {entrega.uf}, {entrega.cep}.</p>
      </>}

      {!!preVenda.produtos.length && <>
        <Divider orientation="left">Produtos</Divider>
        <TabelaPadrao columns={columns} data={preVenda.produtos} style={{ marginTop: 10 }} />
      </>}

      {!!preVenda.servicos.length && <>
        <Divider orientation="left">Serviços</Divider>
        <TabelaPadrao columns={columnsDetServ} data={preVenda.servicos} style={{ marginTop: 10 }} />
      </>}

      {!!preVenda.pagamentos?.length && <>
        <Divider orientation="left">Pagamentos</Divider>
        <TabelaPadrao columns={columnsDetPgto} data={preVenda.pagamentos} />
      </>}

      {preVenda.observacoes && <>
        <LabelPadrao>Observações</LabelPadrao>
        <TextAreaPadrao disabled value={preVenda.observacoes} />
      </>}
    </>}

  </LoadingContainerPadrao>;
}


export default connect(null, { fetch })(PreVendaDetalhesPadrao);

const columns = [
  {
    Header: "Código",
    accessor: "codigo",
    Footer: "Totais",
  },
  {
    Header: "Descrição",
    accessor: "descricao",
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    Cell: props => <div>
      <span>{culture.format(props.row.original?.qtdPaga || props.row.original?.qtd)}</span>
      {!!props.row.original?.qtdExtra && <Tooltip placement="left" title="Quantidade extra">
        <span style={{ paddingLeft: 5, fontSize: "0.9em" }}>({culture.format(props.row.original?.qtdExtra)})</span>
      </Tooltip>}
    </div>,
    tipo: "right",
    SomarQtd: true,
  },
  {
    Header: "Valor unitário",
    accessor: "valorUn",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Desconto",
    accessor: "desconto",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Acréscimo",
    accessor: "acrescimo",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Frete",
    accessor: "valorFrete",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Valor total",
    accessor: "valorTotal",
    tipo: "rs",
    Somar: true
  },
];

const columnsDetServ = [
  {
    Header: "Código",
    accessor: "codigo",
    Footer: " ",
  },
  {
    Header: "Descrição",
    accessor: "descricao",
  },
  {
    Header: "Prestador de serviço",
    accessor: "prestador",
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    tipo: "dec",
    SomarQtd: true,
  },
  {
    Header: "Valor Un.",
    accessor: "valorUn",
    tipo: "rs",
  },
  {
    Header: "Desconto",
    accessor: "desconto",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Acréscimo",
    accessor: "acrescimo",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Total Líquido",
    accessor: "valorTotal",
    tipo: "rs",
    Somar: true,
  },
];


const columnsDetPgto = [
  {
    Header: "Modalidade",
    accessor: "nome",
    Cell: props => <span >{props.row.original.nome}{!!props.row.original?.bandeiraNome ? ` - ${props.row.original?.bandeiraNome}` : ""}</span>,
    Footer: " ",
  },
  {
    Header: "Troco",
    accessor: "troco",
    Cell: props => (props.row.original.tipo == "troco" && !!props.row.original.troco) ? <span>{props.row.original.troco && toLocale(props.row.original.troco)} <span style={{ opacity: 0.5, marginLeft: 10 }}>({toLocale(props.row.original.recebido)})</span></span> : <></>,
  },
  {
    Header: "Valor total",
    accessor: "valor",
    tipo: "rs",
    Somar: true
  }
];